import HomeIconPath from "@ingka/ssr-icon/paths/home";

export default HomeIconPath;
